import { Component, Inject } from '@angular/core';
import { Category } from "../../../../core/models";
import { FormControl } from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

export interface EditCategoryData {
  category: Category;
}

@Component({
    selector: 'app-edit-category-dialog',
    templateUrl: './edit-category-dialog.component.html',
    styleUrls: ['./edit-category-dialog.component.scss'],
    standalone: false
})
export class EditCategoryDialogComponent {

  category: Category;
  newPattern: string;
  control: FormControl = new FormControl<string>('');

  constructor(public dialogRef: MatDialogRef<EditCategoryDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: EditCategoryData) {
    this.category = data.category;
    this.newPattern = this.category.journal_no_pattern;
    this.control.patchValue(this.newPattern);
  }

  onPatternChanged(newPattern: string): void {
    this.newPattern = newPattern;
  }

  saveJournalNoPattern(): void {
    this.dialogRef.close({update: true, value: this.newPattern});
  }

  clearJournalNoPattern() {
    this.dialogRef.close({update: true, value: null});
  }
}
